// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__container {
  display: flex;
  padding: 5px;
  height: 100%;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__rightContainer {
  flex: 5 1 auto;
  display: flex;
  flex-direction: column;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__leftContainer {
  padding: 5px;
  height: 100%;
  overflow-y: auto;
  min-width: 600px;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__AttributesBlockContainer {
  max-width: 100%;
  width: 100%;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableNameContainer {
  padding: 15px;
}
`, "",{"version":3,"sources":["webpack://./app/pages/HR/HRSettings/PeopleTableEditor/PeopleTableEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf","sourcesContent":[".container {\n  display: flex;\n  padding: 5px;\n  height: 100%;\n}\n\n.rightContainer {\n  flex: 5 1 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.leftContainer {\n  padding: 5px;\n  height: 100%;\n  overflow-y: auto;\n  min-width: 600px;\n}\n\n.AttributesBlockContainer {\n  max-width: 100%;\n  width: 100%;\n}\n\n.tableNameContainer {\n  padding: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__container`,
	"rightContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__rightContainer`,
	"leftContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__leftContainer`,
	"AttributesBlockContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__AttributesBlockContainer`,
	"tableNameContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableNameContainer`
};
export default ___CSS_LOADER_EXPORT___;
